<template>
  <v-dialog persistent fullscreen v-model="dialog" max-width="1500">
    <v-card>
      <v-card-title class="border-bottom">
        Stok Hareketleri {{
          (this.stockCodeProp ? ' - ' + 'Stok Kodu ' + this.stockCodeProp : '')
          +
          (this.currentCodeProp ? ' - ' + 'Cari Kodu ' + this.currentCodeProp : '')
        }}
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="py-3 d-flex">
          <div>
            <PrintPage :divId="'printStockActionDetail'"></PrintPage>
            <ExcelExport
                :dataProp="stockActionList"
                :columnProp="stockActionListHeaders"
                :fileNameProp="'Stok Hareketleri' + (this.stockCodeProp ? ' - ' + 'Stok Kodu ' + this.stockCodeProp  : '') +
                  (this.currentCodeProp ? ' - ' + 'Cari Kodu ' + this.currentCodeProp  : '')"
            >

            </ExcelExport>

          </div>
          <div class="ms-auto d-flex">
            <v-select
                class="mr-5 mt-5 pt-3"
                v-model="dashboardFilterReportDbName"
                placeholder="Tüm Şirketler"
                clearable
                solo
                filled
                dense
                :items="companyList"
                :item-text="item => item.name"
                :item-value="item => item.name"
            >
            </v-select>
            <v-text-field
                v-model="searchText"
                class="mt-5 pt-3"
                outlined
                rounded
                dense
                placeholder="Arama Yapın..."
                clearable
                hide-details
                append-icon="mdi-magnify"
                @click:append="searchListWithText()"
                @keydown.enter="searchListWithText()"
            >

            </v-text-field>
          </div>
        </div>
        <div>
          <b-table
              :items="stockActionList"
              :fields="stockActionListHeaders"
              hover
              small
              responsive
              sort-icon-left
              :busy="stockActionListLoading"
              id="printStockActionDetail"
              show-empty
              head-row-variant="info"
              table-variant="white"
          >
            <template #empty="scope">
              <h6 class="text-center my-5">
                {{ scope.loading ? "Lütfen Bekleyin" : errorMessageAll ? errorMessageAll : "Veri Bulunamadı" }}
              </h6>
            </template>
            <template #cell(actionDate)="data">
              {{ formattedDate(data.item.actionDate, "DD-MM-YYYY") }}
            </template>
            <template #cell(actionType)="data">
              {{ data.item.actionType === 1 ? 'Satış' : 'Alış' }}
            </template>
            <template #cell(currencyUnitPrice)="data">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    {{ data.item.currencyUnitPrice }}
                  </div>
                </template>
                <span>{{ "kur: " + (data.item.currencyUnitPrice === 0) ? "Döviz Birim Fiyat Bulunamadı" : data.item.unitPrice / data.item.currencyUnitPrice }}</span>
              </v-tooltip>
            </template>
            <template #table-busy>
              <div class="text-center">
                <b-spinner
                    variant="primary"
                    size="lg"
                    label="Lütfen Bekleyin..."
                ></b-spinner>
              </div>
            </template>
          </b-table>
        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex';
import {formattedDate} from "@/momentHelper";
import {printView} from "../../../../helpers";
import ExcelExport from "@/components/shared/ExcelExport";
import PrintPage from "@/components/shared/PrintPage";

export default {
  name: "StockActionsDialog",
  components: {
    ExcelExport,
    PrintPage
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    currentCodeProp: {
      type: String,
      default: null
    },
    stockCodeProp: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("company", ["companyList"]),
    ...mapState("stock", ["stockActionList", "stockActionListHeaders", "stockActionListLoading"])
  },
  mounted() {
    this.fetchCompanyList({
      params: {},
      body: {}
    });
  },
  data() {
    return {
      dialog: false,
      perPage: 10,
      currentPage: 1,
      totalDebit: 0,
      totalCredit: 0,
      totalBalance: 0,
      searchText: "",
      dashboardFilterReportDbName: null,
    };
  },
  methods: {
    ...mapActions("stock", ["fetchStockActionList"]),
    ...mapMutations("stock", ["setStockActionList"]),
    ...mapActions("company", ["fetchCompanyList"]),

    printView,
    formattedDate,
    closeDialog() {
      this.dialog = false;
    },
    searchListWithText() {
      this.initStockActionList();
    },
    async initStockActionList() {
      switch (this.user.RoleGroupId) {
        case "1":
          await this.fetchStockActionList({
            params: {},
            body: {
              StockCode: this.stockCodeProp,
              ...(!(this.searchText == "" || this.searchText == null)) && {SearchText: this.searchText},
              ...(!(this.dashboardFilterReportDbName === "" || this.dashboardFilterReportDbName === null)) && {ReportDbName: this.dashboardFilterReportDbName},
            }
          });
          break;
        case "2":
          await this.fetchStockActionList({
            params: {},
            body: {
              StockCode: this.stockCodeProp,
              SalesPersonCode: this.user.SalesPersonCode,
              ...(!(this.searchText == "" || this.searchText == null)) && {SearchText: this.searchText},
              ...(!(this.dashboardFilterReportDbName === "" || this.dashboardFilterReportDbName === null)) && {ReportDbName: this.dashboardFilterReportDbName},
            }
          });
          break;
        case "3":
          await this.fetchStockActionList({
            params: {},
            body: {
              StockCode: this.stockCodeProp,
              CurrentCode: this.user.ErpCode,
              ...(!(this.searchText == "" || this.searchText == null)) && {SearchText: this.searchText},
              ...(!(this.dashboardFilterReportDbName === "" || this.dashboardFilterReportDbName === null)) && {ReportDbName: this.dashboardFilterReportDbName},
            }
          });
          break;
      }


    },

  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
      if (newVal)
        this.initStockActionList();
      else
        this.setStockActionList([])

    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
    dashboardFilterReportDbName: function () {
      this.initStockActionList()
    }
  }
}
</script>

<style scoped>

</style>